import React, { useState, useEffect } from "react";
import Filtro from './Filtro';
import Table from './Table';
import ReportAcordeon from '../../../Components/ReportAcordeon'
import { topRanking } from "../../../../../services/NexiDigitalAPI";


const BestInRanking = ({ index, expanded }) => {
    const name = "Conteúdos com mais avaliações"
    const description = "Apresenta o conteúdo visitado pelos usuários com mais avaliações, podendo observar a média e a quantidade de avaliações.";

    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState([]);

    const actionFilter = async (values) => {
        setLoading(true);
        const data = await topRanking(values);
        setDados(data);
        setLoading(false);
    }

    const filter = (
        <Filtro 
            actionFilter={actionFilter} 
            loading={loading} 
        />
    );

    const result = (
        <Table 
            dados={dados} 
            loading={loading} 
        />
    );
    
    return (
        <ReportAcordeon
            name={name}
            description={description}
            filter={filter}
            result={result}
            index={ index }
            expanded={expanded}
        />
        
    )
}

export default BestInRanking;